import { Directive, Host, Optional, Renderer2, Self, ViewContainerRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import * as _ from 'lodash';

@Directive({
  selector: '[FdTablePagination]',
  standalone: true
})
export class FdTablePaginationDirective {
  directiveLoaded = false;
  pagingContainer = document.createElement('div')

  currentNumberofPages = 0;
  firstButtonElementIdentifier: string = "first-page-pagination-button";
  lastButtonElementIdentifier: string = "last-page-pagination-button";
  firstLastEnabledButtonClassName: string = "first-last-page-enabled-button";
  firstLastDisabledButtonClassName: string = "first-last-page-disabled-button";

  get numOfPages(): number {
    return this.matPag.getNumberOfPages() > 0 ? this.matPag.getNumberOfPages() : 1;
  }

  get lastPageIndex(): number {
    return (this.matPag.getNumberOfPages() > 0 ? this.matPag.getNumberOfPages() : 1) - 1;
  }
  constructor(
    @Host() @Self() @Optional() private readonly matPag: MatPaginator,
    private vr: ViewContainerRef,
    private ren: Renderer2
  ) {
    this.matPag.page.subscribe((e) => {
      if (e.previousPageIndex != e.pageIndex)
        this.switchPage(e.pageIndex);

      if (this.numOfPages != this.currentNumberofPages) {
        this.createPages(1);
        this.currentNumberofPages = _.cloneDeep(this.numOfPages);
      }

    });
  }


  public ngAfterViewInit() {
    var count = 0
    var interval = setInterval(() => {
      if (this.numOfPages > 1) {
        this.restructurePagination();
        this.createPages(1);
        this.removeExtraPaginationLabels();
        this.checkFirstAndLastPageState(1);
        this.replaceAllLabel();
        clearInterval(interval);
      }
      if (count > 5) {
        clearInterval(interval);
      }
      count++;
    }, 1000)
    setTimeout(() => {
      this.restructurePagination();
      this.createPages(1);
      this.removeExtraPaginationLabels();
      this.replaceAllLabel();
    }, 1000)
  }

  replaceAllLabel() {
    const paginatorElement = this.vr.element.nativeElement;

    const selectedValueObserver = new MutationObserver(() => {
      const valueText = paginatorElement.querySelector('.mat-mdc-select-value-text span');
      if (valueText && (valueText.innerText.trim() === '999,999' || valueText.innerText.trim() === '999999')) {
        valueText.innerText = 'All';
      }
    });

    const selectElement = paginatorElement.querySelector('mat-select');
    if (selectElement) {
      selectedValueObserver.observe(selectElement, { subtree: true, characterData: true, childList: true });
      const valueText = paginatorElement.querySelector('.mat-mdc-select-value-text span');
      if (valueText && (valueText.innerText.trim() === '999,999' || valueText.innerText.trim() === '999999')) {
        valueText.innerText = 'All';
      }
    }

    const bodyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node: any) => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('cdk-overlay-container')) {
            this.replaceOptionText(node);
          }
          if (node.nodeType === 1 && node.classList && node.classList.contains('mat-mdc-select-panel')) {
            this.replaceOptionsInPanel(node);
          }
          if (node.nodeType === 1 && node.classList && node.classList.contains('cdk-overlay-pane')) {
            const panel = node.querySelector('.mat-mdc-select-panel');
            if (panel) this.replaceOptionsInPanel(panel);
          }
        });
      });
      const overlays = document.querySelectorAll('.cdk-overlay-container .mat-mdc-select-panel');
      overlays.forEach(panel => this.replaceOptionsInPanel(panel as HTMLElement));
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  replaceOptionText(container: HTMLElement) {
    const options = container.querySelectorAll('mat-option .mdc-list-item__primary-text');
    options.forEach((option: any) => {
      if (option.innerText.trim() === '999,999' || option.innerText.trim() === '999999') {
        option.innerText = 'All';
      }
    });
  }

  replaceOptionsInPanel(panel: HTMLElement) {
    const options = panel.querySelectorAll('mat-option .mdc-list-item__primary-text');
    options.forEach((option: any) => {
      if (option.innerText.trim() === '999,999' || option.innerText.trim() === '999999') {
        option.innerText = 'All';
      }
    });
  }

  restructurePagination() {
    this.pagingContainer.classList.add('fd-paging-container');
    this.currentNumberofPages = _.cloneDeep(this.numOfPages);
    if (this.vr.element) {
      var itemsPerPageContainer = this.vr.element.nativeElement.querySelector('.mat-mdc-paginator-page-size');
      var paginatorContainer = this.vr.element.nativeElement.querySelector('.mat-mdc-paginator-container');
      var pageLabelContainer = this.vr.element.nativeElement.querySelector('.mat-mdc-paginator-page-size-label');
      var rangeLabelContainer = this.vr.element.nativeElement.querySelector('.mat-mdc-paginator-range-label');
      var sizeSelect = this.vr.element.nativeElement.querySelector('.mat-mdc-paginator-page-size');
      if (itemsPerPageContainer && paginatorContainer) {
        paginatorContainer.appendChild(itemsPerPageContainer);
        paginatorContainer.setAttribute('style', 'display: flex; align-items: center; justify-content: space-between;padding: 0 8px;flex-wrap: wrap; width: 100%; min-height: var(--mat-paginator-container-size);')
      }
      if (pageLabelContainer) {
        pageLabelContainer.innerHTML = $localize`Showing`;
        rangeLabelContainer.setAttribute('style', 'margin: 0');

        var parent = document.createElement('div');
        parent.classList.add('mat-mdc-paginator-range-actions');
        parent.classList.add('paginator-label-container');
        parent.appendChild(pageLabelContainer);
        parent.appendChild(rangeLabelContainer);

        paginatorContainer.prepend(parent);
      }

      if (sizeSelect && !sizeSelect.querySelector('.pagesize-label')) {
        var pageSizeLabel = document.createElement('span');
        pageSizeLabel.classList.add('pagesize-label');
        if (pageSizeLabel.innerHTML.indexOf('Show:') == -1)
          pageSizeLabel.innerHTML = $localize`Show:`;
        sizeSelect.prepend(pageSizeLabel);
      }
    }
  }

  createPages(activePageNumber: number) {
    var numberOfPages = this.numOfPages;
    var startPage = ((activePageNumber - 2) > 1 ? (activePageNumber - 2) : 1);
    if ((numberOfPages - startPage) < 5) {
      startPage = numberOfPages - 4;
      if (startPage < 1) {
        startPage = 1;
      }
    }

    this.pagingContainer.innerHTML = '';

    var prevButton = this.vr.element.nativeElement.querySelector('button.mat-mdc-paginator-navigation-previous');
    var nextButton = this.vr.element.nativeElement.querySelector('button.mat-mdc-paginator-navigation-next');
    var counter = 1;
    for (let index = startPage; index <= numberOfPages; index++) {
      if (counter > 5) {
        break;
      }
      var page = document.createElement('button');
      page.classList.add('fd-page-number-' + index);
      if (index === 1) {
        page.classList.add('active');
      }
      page.innerHTML = index.toString();
      this.ren.listen(page, 'click', () => {
        this.switchPage(index - 1)
      })

      counter++;
      this.pagingContainer.appendChild(page);
    }

    nextButton.parentNode.insertBefore(this.pagingContainer, nextButton);
    prevButton.html = `<mat-icon matTooltip='previous page' matTooltipPosition='above'>chevron_left</mat-icon>`;
    nextButton.html = `<mat-icon matTooltip='next page' matTooltipPosition='above'>chevron_right</mat-icon>`;
    var firstPageElement = this.vr.element.nativeElement.querySelector('button.' + this.firstButtonElementIdentifier);
    if (!firstPageElement) {
      var firstPageButtonElement = document.createElement('button');
      firstPageButtonElement.classList.add(this.firstButtonElementIdentifier);
      firstPageButtonElement.classList.add("mat-mdc-icon-button");
      firstPageButtonElement.classList.add("mat-mdc-button-base");
      firstPageButtonElement.classList.add(this.firstLastDisabledButtonClassName);
      firstPageButtonElement.setAttribute("disabled", "");
      firstPageButtonElement.addEventListener("click", () => {
        this.matPag.firstPage();
      });
      prevButton.parentNode.insertBefore(firstPageButtonElement, prevButton);
    }

    var lastPageElement = this.vr.element.nativeElement.querySelector('button.' + this.lastButtonElementIdentifier);
    if (!lastPageElement) {
      var lastPageButtonElement = document.createElement('button');
      lastPageButtonElement.classList.add(this.lastButtonElementIdentifier);
      lastPageButtonElement.classList.add("mat-mdc-icon-button");
      lastPageButtonElement.classList.add("mat-mdc-button-base");
      firstPageButtonElement.classList.add(this.firstLastEnabledButtonClassName);
      lastPageButtonElement.setAttribute("mat-icon-button", "");
      lastPageButtonElement.setAttribute("matTooltip", 'last page');
      lastPageButtonElement.setAttribute("matTooltipPosition", 'above');
      if (numberOfPages == 1) {
        lastPageButtonElement.setAttribute("disabled", "");
      }
      lastPageButtonElement.addEventListener("click", () => {
        this.matPag.lastPage();
      });
      nextButton.after(lastPageButtonElement);
    }
  }

  private removeExtraPaginationLabels() {
    var paginatorLabelContainers = document.querySelectorAll('.paginator-label-container');

    if (paginatorLabelContainers.length > 1) {
      for (let i = 0; i < paginatorLabelContainers.length; i++) {
        if (i > 0) {
          paginatorLabelContainers[i].classList.remove('mat-mdc-paginator-range-actions');
          paginatorLabelContainers[i].classList.remove('paginator-label-container');
          paginatorLabelContainers[i].classList.add('display-none');
        }
      }
    }
  }

  private switchPage(i: number): void {
    var currentActivePage = i + 1;
    this.createPages(currentActivePage);
    if (this.pagingContainer.querySelector('.active'))
      this.pagingContainer.querySelector('.active').classList.remove('active');

    if (this.pagingContainer.querySelector('.fd-page-number-' + (currentActivePage)))
      this.pagingContainer.querySelector('.fd-page-number-' + (currentActivePage)).classList.add('active');

    const previousPageIndex = this.matPag.pageIndex;
    this.matPag.pageIndex = i;
    this.matPag["_emitPageEvent"](previousPageIndex);

    this.checkFirstAndLastPageState(currentActivePage);
  }

  refreshPagination() {
    this.ngAfterViewInit();
  }

  private checkFirstAndLastPageState(currentActivePage: number) {
    var firstPageElement = this.vr.element.nativeElement.querySelector('button.' + this.firstButtonElementIdentifier);
    var lastPageElement = this.vr.element.nativeElement.querySelector('button.' + this.lastButtonElementIdentifier);

    if (this.numOfPages === 1) {
      if (firstPageElement) {
        firstPageElement.classList.remove(this.firstLastEnabledButtonClassName);
        firstPageElement.setAttribute('disabled', "");
        firstPageElement.classList.add(this.firstLastDisabledButtonClassName);
      }
      if (lastPageElement) {
        lastPageElement.classList.remove(this.firstLastEnabledButtonClassName);
        lastPageElement.setAttribute('disabled', "");
        lastPageElement.classList.add(this.firstLastDisabledButtonClassName);
      }
    } else {
      if (currentActivePage === 1) {
        if (firstPageElement) {
          firstPageElement.classList.remove(this.firstLastEnabledButtonClassName);
          firstPageElement.setAttribute('disabled', "");
          firstPageElement.classList.add(this.firstLastDisabledButtonClassName);
        }
        if (lastPageElement) {
          lastPageElement.classList.remove(this.firstLastDisabledButtonClassName);
          lastPageElement.removeAttribute('disabled');
          lastPageElement.classList.add(this.firstLastEnabledButtonClassName);
        }
      }
      else if (currentActivePage === this.numOfPages) {
        if (firstPageElement) {
          firstPageElement.classList.remove(this.firstLastDisabledButtonClassName);
          firstPageElement.removeAttribute('disabled');
          firstPageElement.classList.add(this.firstLastEnabledButtonClassName);
        }
        if (lastPageElement) {
          lastPageElement.classList.remove(this.firstLastEnabledButtonClassName);
          lastPageElement.setAttribute('disabled', "");
          lastPageElement.classList.add(this.firstLastDisabledButtonClassName);
        }
      } else {
        if (firstPageElement) {
          firstPageElement.classList.remove(this.firstLastDisabledButtonClassName);
          firstPageElement.removeAttribute('disabled');
          firstPageElement.classList.add(this.firstLastEnabledButtonClassName);
        }
        if (lastPageElement) {
          lastPageElement.classList.remove(this.firstLastDisabledButtonClassName);
          lastPageElement.removeAttribute('disabled');
          lastPageElement.classList.add(this.firstLastEnabledButtonClassName);
        }
      }
    }
  }

}
